// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const necrozma: PokeData = {
  "id": 800,
  "name": "necrozma",
  "height": 24,
  "weight": 2300,
  "base_experience": 270,
  "types": [
    PokeType.PSYCHIC
  ],
  "api_moves": [
    "confusion",
    "slash",
    "metal-claw",
    "morning-sun",
    "moonlight",
    "iron-defense",
    "rock-blast",
    "gravity",
    "wring-out",
    "night-slash",
    "power-gem",
    "psycho-cut",
    "mirror-shot",
    "stealth-rock",
    "charge-beam",
    "autotomize",
    "stored-power",
    "prismatic-laser",
    "photon-geyser"
  ],
  "moves": [
    "metal-claw",
    "morning-sun",
    "moonlight",
    "rock-blast",
    "night-slash",
    "stealth-rock",
    "psywave",
    "calm-mind",
    "psychic",
    "kinesis",
    "future-sight",
    "synchronize",
    "psy-pulse"
  ],
  "evolution_chain": {
    "id": 421,
    "item": null,
    "species": [
      {
        "name": "necrozma",
        "order": 800,
        "types": [
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 127,
    "speed": 105,
    "ability_power": 168
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
